var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#paint0_linear_5_1441)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 37C33 36.4477 32.5523 36 32 36C31.4477 36 31 36.4477 31 37V39C31 39.5523 31.4477 40 32 40C32.5523 40 33 39.5523 33 39V37Z",
    fill: "#3DE8CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 24C26 20.6863 28.6863 18 32 18C35.3137 18 38 20.6863 38 24V31H41C42.1046 31 43 31.8954 43 33V43C43 44.1046 42.1046 45 41 45H23C21.8954 45 21 44.1046 21 43V33C21 31.8954 21.8954 31 23 31H26V24ZM36 24V31H28V24C28 21.7909 29.7909 20 32 20C34.2091 20 36 21.7909 36 24ZM23 33V43H41V33H23Z",
    fill: "#3DE8CA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1441",
    x1: -19.7148,
    y1: 46.9283,
    x2: 39.3853,
    y2: -21.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#146658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CCB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolLock);
export default __webpack_public_path__ + "static/media/school-lock.8092eae1773c7d21b9ee8c4f773a0fed.svg";
export { ForwardRef as ReactComponent };